export default __webpack_public_path__ + "static/media/rental-badge-small.5f3b0a9e.svg";